<p class="asset-name">{{ data.assetName }}</p>
@if (data.propertyValueMessage) {
  @if (data.propertyValue !== null) {
    <p class="property-value">{{ 'VALUE.' + data.propertyValueMessage | translate : {value: data.propertyValue} }}</p>
  } @else {
    <p class="property-value">{{ 'VALUE.' + data.propertyValueMessage + '_NOT_SPECIFIED' | translate }}</p>
  }
}
